import { Section } from '@ria-client/tw-shared-ui/layout/section';

import { RiaTable } from './RiaTable';
import { SectionHeader } from './SectionHeader';
import { BookIcon } from './icons';

const ADVISOR_TYPES_COLUMNS = ['', 'Investment advisors', 'Broker-dealers', 'Financial planners'];

const ADVISOR_TYPES_ROWS = [
  {
    id: 'primary-role',
    cells: [
      'Primary role',
      'Provides investment advice, portfolio management and sometimes creating financial plans.',
      'Buys and sells investments. Some may offer advice related to the trades.',
      'Develops comprehensive financial plans and strategies for retirement, budgeting, insurance, taxes, education, goal-setting, estate planning and investing.',
    ],
  },
  {
    id: 'legal-duty',
    cells: [
      'Legal duty',
      'Fiduciary duty: Investment advisors must put their clients\u2019 interests first at all times.',
      'Suitability standard: Must act in the client\u2019s best interest at the time that the recommendation is made, but not a full fiduciary standard.',
      'Depends on credentials and whether the person also works as or for a broker-dealer. Some financial planners are fiduciaries; some are not.',
    ],
  },
  {
    id: 'standard-of-care',
    cells: [
      'Standard of care',
      'Investment advisors have to uphold a duty of care and loyalty to the client for the duration of their relationship.',
      'Broker-dealers only have a duty of care and loyalty at the time they recommend a product to you.',
      'Varies.',
    ],
  },
  {
    id: 'conflicts-of-interests',
    cells: [
      'Conflicts of Interests',
      'Must disclose, mitigate or eliminate conflicts of interests.',
      'Must disclose conflicts, but can still operate with them if disclosed.',
      'May exist if planner gets commissions from selling financial products to clients. Fee-only planners generally have fewer conflicts.',
    ],
  },
  {
    id: 'fee-structure',
    cells: [
      'Fee structure',
      'Typically a percentage of assets under management, hourly or flat rate.',
      'Typically a fee per trade or per product sold.',
      'May charge fees, commissions, hourly fees, flat fees or combination of some or all of these.',
    ],
  },
  {
    id: 'types-of-compensation',
    cells: [
      'Types of compensation received',
      'Asset-based fees, fees for financial planning work or fixed fees from clients. May also receive payments from third-parties for recommending their products/services, if disclosed. (This is a conflict of interest.)',
      'Commissions, markups/markdowns, sales loads, and sometimes revenue sharing from product providers.',
      'May receive hourly fees, fees that are a percentage of assets under management (AUM), referral fees and commissions for the sale of insurance or mutual funds.',
    ],
  },
  {
    id: 'client-relationship',
    cells: [
      'Client relationship',
      'Ongoing.',
      'Usually transactional.',
      'Usually ongoing and comprehensive.',
    ],
  },
  {
    id: 'regulatory-oversight',
    cells: [
      'Primary regulatory oversight',
      'Investment Advisers Act of 1940.',
      'Securities Exchange Act of 1934 and FINRA.',
      'Varies by type of service. Oversight might come from the U.S. Securities and Exchange Commission, state securities regulators or industry bodies such as Financial Industry Regulatory Authority. Some professional designations, such as the Certified Financial Planner (CFP) designation, require members to follow certain ethical standards.',
    ],
  },
];

export function TypesOfAdvisors() {
  return (
    <Section aria-label="Types of advisors" bg="paper" bordered>
      <SectionHeader
        icon={<BookIcon className="size-4.5" />}
        gradient="yellow"
        title="Types of advisors"
        subtitle="&ldquo;Financial advisor&rdquo; is a catch-all term that describes a wide variety of advisors, including investment advisors and managers, broker-dealers and financial planners. All of these advisors may be able to help you make investment decisions, but choosing the right type for you gets a bit more complex. Here's an overview of the differences between investment advisors, broker dealers and financial planners. "
      />
      <RiaTable
        aria-label="Advisor type comparison"
        columns={ADVISOR_TYPES_COLUMNS}
        rows={ADVISOR_TYPES_ROWS}
        rowHeaderColumn
        preserveFirstColumnLineBreaks={false}
      />
    </Section>
  );
}
